import { Box, styled } from '@mui/material'

export const OurResultsWrapper = styled(Box)(() => ({
  backgroundImage: `url('/assets/ourResults/heroCover.svg')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  maxWidth: '1920px',
  marginLeft: 'auto',
  marginRight: 'auto',
}))

export const HeroWrapper = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(10),
  paddingBottom: theme.spacing(10),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
  backgroundImage: `url('/assets/ourResults/heroBackgroundColor.svg')`,
  backgroundSize: 'contain',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
}))

export const MainHeroText = styled(Box)(({ theme }) => ({
  ...theme.typography.h5,
  fontWeight: 500,
  color: theme.palette.surface[200],
  textAlign: 'center',
  '& mark': {
    ...theme.typography.landingHero,
    background: 'transparent',
    color: theme.palette.primary[500],
    '& span': {
      color: theme.palette.surface[400],
    },
  },
  [theme.breakpoints.up('sm')]: {
    ...theme.typography.h2,
    fontSize: '50px',
    fontWeight: 500,
    '& mark': {
      fontSize: '112px',
    },
  },
}))

export const Divider = styled(Box)(({ theme }) => ({
  width: '224px',
  height: '1px',
  background: theme.palette.primary[500],
}))

export const SecondaryText = styled(Box)(({ theme }) => ({
  ...theme.typography.body1,
  color: theme.palette.surface[50],
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    ...theme.typography.subtitle1,
  },
}))

export const AwardsSectionContainer = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(4),
}))
